"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialAnalysisAspectsRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.FinancialAnalysisAspectsRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.financial_analysis_aspects.label',
    fallbackLabel: 'Financial analysis',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'LIQUIDITY', label: 'fields.enm.financial_analysis_aspects.options.LIQUIDITY', fallbackLabel: 'Liquidity Analysis. Example indicators: current ratio, cash on hand' },
        { key: 'SOLVENCY', label: 'fields.enm.financial_analysis_aspects.options.SOLVENCY', fallbackLabel: 'Solvency Analysis. Example indicators: interest coverage, equity ratio, debt status' },
        { key: 'PROFITABILITY', label: 'fields.enm.financial_analysis_aspects.options.PROFITABILITY', fallbackLabel: 'Profitability Analysis. Example indicators: EBITDA change, return-on-assets' },
        { key: 'NO_REVIEWS', label: 'fields.enm.financial_analysis_aspects.options.NO_REVIEWS', fallbackLabel: 'We do not perform dedicated financial assessments on merchants' },
    ],
    trackFieldValueWithAnalytics: false,
};
